import { logger } from "@/utils/log";
import { PhoneNumberUtil, PhoneNumberFormat } from "google-libphonenumber";
import store from "@/store";

function parsePhoneNumber(phoneNumber) {
  const phoneUtil = PhoneNumberUtil.getInstance();
  const numberRaw = phoneNumber.startsWith('+') ? phoneUtil.parseAndKeepRawInput(phoneNumber) : phoneUtil.parseAndKeepRawInput(phoneNumber, 'US');
  const regionCode = phoneUtil.getRegionCodeForNumber(numberRaw);

  return {
    phoneCountry: regionCode,
    phone: numberRaw.getNationalNumber().toString(),
  }
}

function stringifyPhoneNumber(phoneCountry, phone) {
  const phoneUtil = PhoneNumberUtil.getInstance();
  const numberRaw = phoneUtil.parseAndKeepRawInput(phone, phoneCountry);
  return phoneUtil.format(numberRaw, PhoneNumberFormat.E164);
}

function isValidPhoneNumber(phoneNumber, phoneCountry) {
  if (store.getters.confirmContinueWithErrorPhone) {
    return true
  }
  try {
    const phoneUtil = PhoneNumberUtil.getInstance();
    const numberRaw = (phoneNumber || '').startsWith('+') ? phoneUtil.parseAndKeepRawInput(phoneNumber || '') : phoneUtil.parseAndKeepRawInput(phoneNumber || '', phoneCountry || 'US');
    return phoneUtil.isValidNumber(numberRaw);
  } catch (e) {
    logger.log(e);
  }
  return false
}

export { parsePhoneNumber, stringifyPhoneNumber, isValidPhoneNumber };
